// Generated from GTM Reference files. Keep this data GTM-specific and business-readable.

export const checklistItems = [
  {
    "id": "ck-001",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "GTM",
    "activity": "市场洞察",
    "deliverable": "输出市场洞察报告",
    "note": "包含不同国家市场大盘、渠道类型、价格段市场空间、竞品分布、消费者购物习惯等信息。"
  },
  {
    "id": "ck-002",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "GTM",
    "activity": "沟通各国需求",
    "deliverable": "输出产品需求清单",
    "note": "包含不同区域、重点国家针对产品、零售、营销的差异化需求，针对竞品的应对策略。"
  },
  {
    "id": "ck-003",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "GTM",
    "activity": "输出产品生命周期销量预测",
    "deliverable": "产品生命周期销量预测",
    "note": "早期销量预测，根据旧品历史销量数据，结合增长目标预测。"
  },
  {
    "id": "ck-004",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "营销经理",
    "activity": "调研消费者用户画像",
    "deliverable": "用户画像",
    "note": ""
  },
  {
    "id": "ck-005",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "产品线-MO",
    "activity": "调研消费者对产品功能卖点需求",
    "deliverable": "产品功能需求清单",
    "note": "结合终端导购反馈、VOC数据和竞品功能对标，梳理消费者对智能马桶等产品的核心功能需求优先级。"
  },
  {
    "id": "ck-006",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "电商经理",
    "activity": "调研电商消费者需求",
    "deliverable": "电商消费者洞察报告",
    "note": "分析线上搜索关键词、评价数据、退货原因，提炼电商渠道消费者对产品的关注点和痛点。"
  },
  {
    "id": "ck-007",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "服务经理",
    "activity": "收集服务需求",
    "deliverable": "服务需求与痛点清单",
    "note": "收集售后服务、安装交付环节的客户投诉和改进建议，输出产品在服务端的需求和约束条件。"
  },
  {
    "id": "ck-008",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "渠道经理",
    "activity": "收集渠道反馈",
    "deliverable": "渠道反馈报告",
    "note": "收集零售高定渠道、经销商对产品定位、价格带、竞品应对的反馈，形成渠道端需求输入。"
  },
  {
    "id": "ck-009",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "财务经理",
    "activity": "输出产品生命周期财务概算",
    "deliverable": "产品生命周期财务概算",
    "note": "结合GTM给出的量价预测，以及成本经理给出的成本预测，进行概算。"
  },
  {
    "id": "ck-010",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "GTM",
    "activity": "召开区域PCT启动会（Kick Off）",
    "deliverable": "项目维度：PCT成员名单、GTM Checklist\n产品维度：五点三包的预计输出时间",
    "note": ""
  },
  {
    "id": "ck-011",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "PCT团队",
    "activity": "评审GR1",
    "deliverable": "评审结论",
    "note": ""
  },
  {
    "id": "ck-012",
    "stageKey": "planning_initiation",
    "stageName": "1 - 规划与立项",
    "role": "GTM-MT委员",
    "activity": "决策CDCP",
    "deliverable": "决策结论",
    "note": ""
  },
  {
    "id": "ck-013",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "产品线-MO",
    "activity": "提供产品功能卖点概述",
    "deliverable": "产品功能卖点概述",
    "note": ""
  },
  {
    "id": "ck-014",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "GTM",
    "activity": "制定区域产品上市策略纲要",
    "deliverable": "区域产品上市策略纲要",
    "note": "产品介绍、竞争分析、BP任务分解"
  },
  {
    "id": "ck-015",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "产品线-MO",
    "activity": "提供产品具体功能卖点及技术支撑点",
    "deliverable": "产品功能卖点及技术支撑点",
    "note": ""
  },
  {
    "id": "ck-016",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "GTM",
    "activity": "输出产品卖点排序及产品拓展材料初稿",
    "deliverable": "产品卖点排序及产品拓展材料初稿",
    "note": "属于五点三包中的交付件"
  },
  {
    "id": "ck-017",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "营销经理",
    "activity": "制定营销策略纲要及营销预算",
    "deliverable": "营销策略纲要及营销预算",
    "note": ""
  },
  {
    "id": "ck-018",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "营销经理",
    "activity": "输出面向消费者的产品卖点初稿",
    "deliverable": "面向消费者的产品卖点初稿",
    "note": ""
  },
  {
    "id": "ck-019",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "GTM",
    "activity": "输出生命周期整体销量预测",
    "deliverable": "生命周期整体销量预测",
    "note": "第二版量价预测，参与PDCP评审"
  },
  {
    "id": "ck-020",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "供应链经理",
    "activity": "制定长周期核心部件备料计划",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-021",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "GTM",
    "activity": "收集区域市场拓展样机需求",
    "deliverable": "市场拓展样机需求汇总",
    "note": ""
  },
  {
    "id": "ck-022",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "GTM",
    "activity": "汇总并评审区域GTM策略",
    "deliverable": "待补充交付件",
    "note": "区域GTM邀请国家上市方案评审"
  },
  {
    "id": "ck-023",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "渠道经理",
    "activity": "制定渠道政策及费用预算",
    "deliverable": "渠道政策及费用预算",
    "note": "渠长测算"
  },
  {
    "id": "ck-024",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "电商经理",
    "activity": "制定电商策略及费用预算",
    "deliverable": "电商策略及费用预算",
    "note": ""
  },
  {
    "id": "ck-025",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "零售经理",
    "activity": "制定零售策略及费用预算",
    "deliverable": "零售策略及费用预算",
    "note": ""
  },
  {
    "id": "ck-026",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "服务经理",
    "activity": "制定服务策略及费用预算",
    "deliverable": "服务策略及费用预算",
    "note": ""
  },
  {
    "id": "ck-027",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "财务经理",
    "activity": "编制产品费用预算",
    "deliverable": "产品费用预算",
    "note": "结合量价预测、费用预算，做生命周期损益测算"
  },
  {
    "id": "ck-028",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "PDT经理",
    "activity": "输出产品规格明细及预估成本",
    "deliverable": "产品规格明细及预估成本",
    "note": ""
  },
  {
    "id": "ck-029",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "PCT团队",
    "activity": "评审GR2",
    "deliverable": "评审结论",
    "note": ""
  },
  {
    "id": "ck-030",
    "stageKey": "expansion_preparation",
    "stageName": "2 - 拓展准备",
    "role": "GTM-MT委员",
    "activity": "决策DCP2",
    "deliverable": "决策结论",
    "note": "PDCP"
  },
  {
    "id": "ck-031",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "PDT经理",
    "activity": "交付市场拓展样机或手板",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-032",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "GTM",
    "activity": "输出产品拓展包",
    "deliverable": "产品拓展包",
    "note": "五点三包交付件之一"
  },
  {
    "id": "ck-033",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "PCT团队",
    "activity": "评审M+6要货预测及定制化需求",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-034",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "供应链经理",
    "activity": "筹备新品物料",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-035",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "营销经理",
    "activity": "制定IMC整合营销方案",
    "deliverable": "IMC整合营销方案",
    "note": ""
  },
  {
    "id": "ck-036",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "渠道经理",
    "activity": "制定渠道拓展及覆盖计划",
    "deliverable": "渠道拓展及覆盖计划",
    "note": ""
  },
  {
    "id": "ck-037",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "零售经理",
    "activity": "制定零售方案及零售物料设计",
    "deliverable": "零售方案及零售物料设计",
    "note": ""
  },
  {
    "id": "ck-038",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "电商经理",
    "activity": "制定产品电商运营方案",
    "deliverable": "电商运营方案",
    "note": ""
  },
  {
    "id": "ck-039",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "服务经理",
    "activity": "制定产品服务方案",
    "deliverable": "产品服务方案",
    "note": ""
  },
  {
    "id": "ck-040",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "GTM",
    "activity": "制定区域GTM操盘方案",
    "deliverable": "区域GTM操盘方案",
    "note": "综合国家的上市方案汇总"
  },
  {
    "id": "ck-041",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "财务经理",
    "activity": "管理费用预算审批",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-042",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "GTM",
    "activity": "启动区域产品操盘方案收集",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-043",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "GTM",
    "activity": "汇总及评审区域产品操盘方案",
    "deliverable": "重点国家产品GTM操盘方案",
    "note": ""
  },
  {
    "id": "ck-044",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "PCT团队",
    "activity": "评审GR3",
    "deliverable": "评审结论",
    "note": ""
  },
  {
    "id": "ck-045",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "GTM-MT委员",
    "activity": "决策DCP3",
    "deliverable": "决策结论",
    "note": "GR3"
  },
  {
    "id": "ck-046",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "供应链经理",
    "activity": "评估及确认国家首批订单及发货需求",
    "deliverable": "首单备料计划",
    "note": ""
  },
  {
    "id": "ck-047",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "渠道经理",
    "activity": "输出渠道要货预测",
    "deliverable": "渠道要货预测",
    "note": ""
  },
  {
    "id": "ck-048",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "零售经理",
    "activity": "输出零售培训材料，零售物料交付",
    "deliverable": "零售培训材料",
    "note": ""
  },
  {
    "id": "ck-049",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "电商经理",
    "activity": "落地电商运营方案及物料",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-050",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "服务经理",
    "activity": "本地化服务方案",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-051",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "供应链经理",
    "activity": "确定M+6要货预测",
    "deliverable": "M+6要货预测",
    "note": ""
  },
  {
    "id": "ck-052",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "PDT经理",
    "activity": "把控产品上市时间及风险",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-053",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "PCT团队",
    "activity": "评审GR4",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-054",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "GTM",
    "activity": "检查区域操盘方案落地情况",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-055",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "营销经理",
    "activity": "检查发布会准备度",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-056",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "电商经理",
    "activity": "检查电商准备度",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-057",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "服务经理",
    "activity": "检查服务准备度",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-058",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "供应链经理",
    "activity": "检查产品交付能力",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-059",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "区域/国家GTM",
    "activity": "检查产品上市准备度(checklist)",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-060",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "GTM",
    "activity": "把控上市准备度",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-061",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "零售经理",
    "activity": "执行零售物料作业及零售培训",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-062",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "供应链经理",
    "activity": "检查全球发货情况（含首批发货执行）",
    "deliverable": "评审结论",
    "note": ""
  },
  {
    "id": "ck-063",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "PCT团队",
    "activity": "评审GR5",
    "deliverable": "决策结论",
    "note": ""
  },
  {
    "id": "ck-064",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "GTM-MT委员",
    "activity": "决策DCP4",
    "deliverable": "待补充交付件",
    "note": "GR4"
  },
  {
    "id": "ck-065",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "营销经理",
    "activity": "召开产品发布会",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-066",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "供应链经理",
    "activity": "检查实际交付情况",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-067",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "GTM",
    "activity": "监控区域首销及竞争情况",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-068",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "GTM",
    "activity": "监控区域操盘方案执行及销售",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-069",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "营销经理",
    "activity": "监控营销方案执行",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-070",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "渠道经理",
    "activity": "监控渠道PSI及日常管理",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-071",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "零售经理",
    "activity": "监控零售方案的执行情况",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-072",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "电商经理",
    "activity": "监控电商方案执行情况",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-073",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "服务经理",
    "activity": "监控服务方案执行情况",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-074",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "GTM",
    "activity": "管理每周PSI",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-075",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "供应链经理",
    "activity": "管理滚动要货计划",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-076",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "GTM",
    "activity": "监控每周SO达成情况及竞品价格",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-077",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "营销经理",
    "activity": "复盘IMC执行情况，输出复盘报告",
    "deliverable": "IMC方案复盘报告",
    "note": ""
  },
  {
    "id": "ck-078",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "电商经理",
    "activity": "复盘电商首销情况，输出电商复盘报告",
    "deliverable": "电商首销复盘报告",
    "note": ""
  },
  {
    "id": "ck-079",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "财务经理",
    "activity": "执行及监控预算达成进度",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-080",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "GTM",
    "activity": "复盘首销上市情况，输出首销上市复盘报告",
    "deliverable": "首销复盘报告",
    "note": ""
  },
  {
    "id": "ck-081",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "PDT经理",
    "activity": "收集产品市场反馈",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-082",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "GTM-MT委员",
    "activity": "决策DCP5",
    "deliverable": "决策结论",
    "note": "GR5"
  },
  {
    "id": "ck-083",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "GTM",
    "activity": "输出前端市场信息支撑产品线新品规划",
    "deliverable": "新品规划",
    "note": ""
  },
  {
    "id": "ck-084",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "产品规划",
    "activity": "规划迭代产品",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-085",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "GTM",
    "activity": "调整销售节奏及策略",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-086",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "GTM",
    "activity": "评审GR5A",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-087",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "营销经理",
    "activity": "维持多波次的营销声量",
    "deliverable": "联合营销方案、战报",
    "note": "GTM代表在稳定销售的过程中要挖掘战报中的亮点，做内、外部营销"
  },
  {
    "id": "ck-088",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "电商经理",
    "activity": "管理电商促销活动，提升转化",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-089",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "服务经理",
    "activity": "监控VOC，及时处理产品售后问题",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-090",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "零售经理",
    "activity": "零售方案复盘",
    "deliverable": "零售复盘报告",
    "note": ""
  },
  {
    "id": "ck-091",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "服务经理",
    "activity": "服务阶段复盘",
    "deliverable": "服务阶段复盘报告",
    "note": ""
  },
  {
    "id": "ck-092",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "供应链经理",
    "activity": "管理滚动要货计划",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-093",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "财务经理",
    "activity": "输出月度产品经营数据",
    "deliverable": "月度产品经营偏差分析",
    "note": ""
  },
  {
    "id": "ck-094",
    "stageKey": "stable_sales",
    "stageName": "6 - 稳定销售",
    "role": "GTM",
    "activity": "管理PSI",
    "deliverable": "待补充交付件",
    "note": ""
  },
  {
    "id": "ck-095",
    "stageKey": "phase_out",
    "stageName": "7 - 退市操盘",
    "role": "GTM",
    "activity": "制定产品退市方案",
    "deliverable": "产品退市方案",
    "note": "发布EOM公告"
  },
  {
    "id": "ck-096",
    "stageKey": "phase_out",
    "stageName": "7 - 退市操盘",
    "role": "渠道经理",
    "activity": "制定渠道清尾方案",
    "deliverable": "渠道清尾方案",
    "note": "准备Last Buy方案"
  },
  {
    "id": "ck-097",
    "stageKey": "phase_out",
    "stageName": "7 - 退市操盘",
    "role": "服务经理",
    "activity": "制定退市服务方案",
    "deliverable": "退市服务方案",
    "note": ""
  },
  {
    "id": "ck-098",
    "stageKey": "phase_out",
    "stageName": "7 - 退市操盘",
    "role": "GTM",
    "activity": "明确新品接续计划",
    "deliverable": "新品接续计划（路标）",
    "note": "刷新产品路标，准备下一代产品沟通。"
  },
  {
    "id": "ck-099",
    "stageKey": "phase_out",
    "stageName": "7 - 退市操盘",
    "role": "PCT团队",
    "activity": "评审GR6",
    "deliverable": "评审结论",
    "note": ""
  },
  {
    "id": "ck-100",
    "stageKey": "phase_out",
    "stageName": "7 - 退市操盘",
    "role": "GTM-MT委员",
    "activity": "决策DCP6",
    "deliverable": "决策结论",
    "note": ""
  },
  {
    "id": "ck-101",
    "stageKey": "phase_out",
    "stageName": "7 - 退市操盘",
    "role": "财务经理",
    "activity": "输出产品经营分析数据及报告",
    "deliverable": "经营分析报告",
    "note": ""
  },
  {
    "id": "ck-102",
    "stageKey": "phase_out",
    "stageName": "7 - 退市操盘",
    "role": "服务经理",
    "activity": "服务阶段复盘",
    "deliverable": "服务阶段复盘报告",
    "note": ""
  },
  {
    "id": "ck-103",
    "stageKey": "phase_out",
    "stageName": "7 - 退市操盘",
    "role": "PCT团队",
    "activity": "产品生命周期复盘",
    "deliverable": "产品生命周期复盘报告",
    "note": ""
  },
  {
    "id": "ck-104",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "渠道经理",
    "activity": "输出渠道政策及费用预算",
    "deliverable": "渠道政策及费用预算终稿",
    "note": "基于前期制定的渠道政策，输出最终版本并提交审批"
  },
  {
    "id": "ck-105",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "GTM",
    "activity": "跟踪渠道导入执行进度",
    "deliverable": "渠道导入进度报告",
    "note": "定期跟踪各区域渠道导入的执行情况，识别阻塞问题"
  },
  {
    "id": "ck-106",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "渠道经理",
    "activity": "评估渠道覆盖计划达成情况",
    "deliverable": "渠道覆盖评估报告",
    "note": "对比计划与实际覆盖情况，分析差距并制定改进措施"
  },
  {
    "id": "ck-107",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "营销经理",
    "activity": "审核营销预算及资源分配",
    "deliverable": "营销预算审批单",
    "note": "对IMC方案中的预算进行审核，确保资源分配合理"
  },
  {
    "id": "ck-108",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "营销经理",
    "activity": "确认传播渠道及投放排期",
    "deliverable": "传播渠道排期表",
    "note": "确认各传播渠道的投放时间节点和内容安排"
  },
  {
    "id": "ck-109",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "GTM",
    "activity": "输出营销方案终稿",
    "deliverable": "IMC整合营销方案终稿",
    "note": "汇总各方意见，输出最终版营销方案"
  },
  {
    "id": "ck-110",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "GTM",
    "activity": "整理产品卖点及技术支撑文档",
    "deliverable": "产品卖点技术支撑文档",
    "note": "梳理产品核心卖点，整理技术参数和支撑材料"
  },
  {
    "id": "ck-111",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "零售经理",
    "activity": "准备产品卖点演示及培训素材",
    "deliverable": "产品演示PPT及培训视频",
    "note": "制作面向渠道和终端的产品演示素材及培训资料"
  },
  {
    "id": "ck-112",
    "stageKey": "market_expansion",
    "stageName": "3 - 市场拓展",
    "role": "GTM",
    "activity": "输出内容资产清单及使用规范",
    "deliverable": "内容资产管理清单",
    "note": "整理所有内容资产，制定使用规范和分发计划"
  },
  {
    "id": "ck-113",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "GTM",
    "activity": "协调各部门上市执行准备",
    "deliverable": "上市执行准备确认单",
    "note": "统筹各部门（供应链、营销、渠道、零售）上市前的准备工作"
  },
  {
    "id": "ck-114",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "GTM",
    "activity": "确认首发时间及销售策略",
    "deliverable": "首发执行计划",
    "note": "确认产品首发时间、定价策略及首批销售目标"
  },
  {
    "id": "ck-115",
    "stageKey": "launch_sales",
    "stageName": "5 - 上市销售",
    "role": "GTM",
    "activity": "监控首发上市执行及反馈收集",
    "deliverable": "首销监控日报",
    "note": "首发期间每日监控销售数据、库存状态及市场反馈"
  },
  {
    "id": "ck-116",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "零售经理",
    "activity": "完成导购培训及话术考核",
    "deliverable": "导购培训完成确认单",
    "note": "组织导购进行产品知识、卖点话术培训，并完成考核"
  },
  {
    "id": "ck-117",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "渠道经理",
    "activity": "完成渠道培训及政策宣导",
    "deliverable": "渠道培训记录",
    "note": "对渠道伙伴进行产品培训、政策解读和销售激励宣导"
  },
  {
    "id": "ck-118",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "零售经理",
    "activity": "确认终端陈列标准及道具",
    "deliverable": "终端陈列标准手册",
    "note": "制定并确认门店陈列方案、展示道具和POP物料"
  },
  {
    "id": "ck-119",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "营销经理",
    "activity": "输出主视觉及宣传物料",
    "deliverable": "主视觉及宣传物料包",
    "note": "完成产品主视觉设计、宣传单页、海报等物料制作"
  },
  {
    "id": "ck-120",
    "stageKey": "launch_preparation",
    "stageName": "4 - 上市准备",
    "role": "服务经理",
    "activity": "建立售后知识库及工单预案",
    "deliverable": "售后知识库V1.0",
    "note": "整理新品常见问题、维修方案和服务工单处理流程"
  }
];

export const l2SubProcesses = {
  planning_initiation: [
    { name: "市场机会识别", desc: "扫描卫浴大盘、零售高定/电商/渠道趋势、价格段空间与竞品格局，形成新品机会判断和市场洞察" },
    { name: "用户需求洞察", desc: "整合消费者调研、终端导购、经销商、电商评价、VOC和服务工单，形成产品需求与渠道需求图谱" },
    { name: "产品概念与商业模式设计", desc: "完成卖点模拟、产品定位、价格带、渠道组合、生命周期量价预测和初步经营模型" },
    { name: "可行性评估与立项决策", desc: "组织KICKOFF/GR1，完成收益测算、风险评估、PCT成员确认，并与IPD CDCP节点互锁" },
  ],
  expansion_preparation: [
    { name: "产品定义确认", desc: "确认产品规格、核心卖点、技术支撑点、产品传播名和价格交流口径" },
    { name: "上市路径设计", desc: "制定全球/区域上市操盘方案、首发路径、拓展节奏、样板市场和关键里程碑" },
    { name: "目标渠道与客群规划", desc: "明确零售高定、电商、渠道、服务等场景的目标客群、覆盖计划和差异化打法" },
    { name: "项目资源配置与计划编制", desc: "落实PCT协同、样机计划、费用预算、长周期备料和GR2/PDCP所需交付物" },
  ],
  market_expansion: [
    { name: "渠道拓展准备", desc: "制定渠道和零售规划、需求预测、投放方案、联合营销和门店/经销商导入计划" },
    { name: "市场推广策略设计", desc: "制定IMC整合营销、发布会策略、媒介投放、传播节奏和预算方案" },
    { name: "产品卖点与内容资产准备", desc: "输出主打卖点、产品传播名、拓展包、营销材料包、零售物料包等五点三包内容" },
    { name: "上市资源前置协同", desc: "完成样机、物料、培训、服务、备料和供应策略前置准备，支撑GR3早期样机评审" },
  ],
  launch_preparation: [
    { name: "上市成熟度检查", desc: "围绕TR4A/TR5/GR4检查产品、价格、物料、渠道、服务、交付、系统数据是否达到上市条件" },
    { name: "物料准备", desc: "确认主视觉、销售工具、终端陈列、零售物料包、营销材料包和电商商品页面内容" },
    { name: "培训准备", desc: "完成拓展包下发、渠道/导购/服务培训、话术演练、奥情反馈机制和终端执行标准" },
    { name: "服务准备", desc: "导入服务平台、服务策略、安装交付标准、售后知识库和高线区域服务保障" },
    { name: "库存和交付准备", desc: "确认首批订单、首销分货、发货计划、物流仓储、备料节奏和按订单交付能力" },
    { name: "系统及数据准备", desc: "完成价格授权、商品主数据、电商Listing、客户邀请、发布会准备度和系统上线检查" },
  ],
  launch_sales: [
    { name: "首发上市执行", desc: "发布会/上市上线、零售终端执行、电商页面开售、渠道承接和服务保障同步启动" },
    { name: "终端导入与渠道激活", desc: "监控零售、街价、DOS、渠道PSI、客户销售管理、串货管理和渠道激励" },
    { name: "上市传播与转化运营", desc: "执行IMC传播、区域奥情监控、媒介资源投放、电商活动和营销ROI评估" },
    { name: "首销复盘", desc: "围绕首销表现、渠道反馈、价格表现、库存健康和消费者问题输出GR5复盘结论" },
  ],
  stable_sales: [
    { name: "动销监控", desc: "持续监控Sell-out、Retail Price、DOS、PSI、销售达成、竞品价格和滚动要货预测" },
    { name: "问题闭环与改进", desc: "管理VOC、售后问题、花特运作、渠道问题和产品改进事项，形成闭环台账" },
    { name: "产品经营优化", desc: "按月/季度复盘经营、营销投入产出、零售方案、服务质量和价格策略，刷新优化动作" },
    { name: "资源调整与持续经营", desc: "根据经营表现调整预算、投放、库存、渠道资源和后续产品生命周期策略" },
  ],
  phase_out: [
    { name: "退市判断", desc: "基于生命周期、销售趋势、毛利、库存和替代品规划，形成EOM/EOX退市判断" },
    { name: "库存与渠道处理", desc: "制定尾盘清库、Last Buy、EOS、渠道清尾、停供供货和库存消化策略" },
    { name: "价格与客户影响管理", desc: "管理退市价格、客户沟通、服务延续、备件保障和渠道影响，降低尾盘冲击" },
    { name: "经验复盘与知识沉淀", desc: "输出生命周期案例复盘、经营总结、问题教训和下一代产品/上市策略输入" },
  ],
};

export const l3Flows = {
  planning_initiation: {
    "市场机会识别": {
      code: "L2-01-01",
      start: "机会识别触发",
      end: "市场洞察确认",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-01-01-01", name: "市场洞察", input: "行业报告、历史数据", output: "市场洞察报告", note: "扫描卫浴行业大盘（智能马桶/花洒/浴室柜等品类），分析不同国家市场容量、渠道类型（零售高定/电商/工程）、价格段空间、竞品分布、消费者购物习惯。" },
          { id: "gtm_2", code: "L3-01-01-02", name: "沟通各国需求", input: "区域市场信息", output: "需求汇总", note: "收集不同区域、重点国家针对产品功能、零售体验、营销传播的差异化需求，以及针对竞品（如TOTO、科勒等）的应对策略。" },
          { id: "gtm_3", code: "L3-01-01-04", name: "输出生命周期销量预测", input: "市场数据、需求汇总", output: "销量预测", note: "基于市场洞察和各国需求，参考旧品历史销量数据，结合增长目标，预测产品全生命周期（通常18-24个月）的分区域销量表现。" },
        ],
        "渠道经理": [
          { id: "ch_1", code: "L3-01-01-03", name: "收集渠道反馈", input: "渠道销售数据", output: "渠道反馈报告", note: "收集零售高定渠道、经销商端对产品定位、价格带、竞品应对的反馈意见，特别是终端门店的一线声音。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "ch_1", ""],
        ["gtm_1", "gtm_2", "市场洞察报告"],
        ["ch_1", "gtm_3", "渠道反馈报告"],
        ["gtm_2", "gtm_3", "需求汇总"],
        ["gtm_3", "End", "销量预测"],
      ],
    },
    "用户需求洞察": {
      code: "L2-01-02",
      start: "洞察启动",
      end: "需求图谱确认",
      lanes: {
        "营销经理": [
          { id: "mkt_1", code: "L3-01-02-01", name: "调研消费者用户画像", input: "消费者调研、社媒数据", output: "用户画像", note: "通过消费者调研、社交媒体聆听、终端访谈等方式，构建目标用户画像（如新中产家庭、改善型住房用户），明确其购买决策链路和关注要素。" },
        ],
        "产品线-MO": [
          { id: "prod_1", code: "L3-01-02-02", name: "调研产品功能需求", input: "VOC数据、竞品功能对标", output: "产品功能需求清单", note: "结合终端导购反馈、VOC数据和竞品功能对标（如智能马桶的自动翻盖、脚感冲水、座圈加热等），梳理消费者核心功能需求优先级。" },
        ],
        "电商经理": [
          { id: "ec_1", code: "L3-01-02-03", name: "调研电商消费者需求", input: "搜索词、评价、退货数据", output: "电商消费者洞察报告", note: "分析线上搜索关键词热度、商品评价情感分析、退货原因分布，提炼电商渠道消费者对产品的关注点和痛点。" },
        ],
        "服务经理": [
          { id: "svc_1", code: "L3-01-02-04", name: "收集服务需求", input: "售后工单、安装反馈", output: "服务需求与痛点清单", note: "收集售后服务、安装交付环节的客户投诉和改进建议，输出产品在服务端的需求和约束条件（如安装条件、水压要求等）。" },
        ],
        "GTM": [
          { id: "gtm_1", code: "L3-01-02-05", name: "汇总需求图谱", input: "各域洞察报告", output: "需求图谱", note: "汇总营销、产品、电商、服务各域的洞察结果，形成结构化的需求图谱，作为产品概念设计的输入。" },
        ],
      },
      connections: [
        ["Start", "mkt_1", ""],
        ["Start", "prod_1", ""],
        ["Start", "ec_1", ""],
        ["Start", "svc_1", ""],
        ["mkt_1", "gtm_1", "用户画像"],
        ["prod_1", "gtm_1", "功能需求清单"],
        ["ec_1", "gtm_1", "电商洞察报告"],
        ["svc_1", "gtm_1", "服务需求清单"],
        ["gtm_1", "End", "需求图谱"],
      ],
    },
    "产品概念与商业模式设计": {
      code: "L2-01-03",
      start: "概念设计启动",
      end: "产品概念确认",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-01-03-01", name: "制定区域产品上市策略纲要", input: "需求图谱、市场洞察", output: "上市策略纲要", note: "基于需求图谱和市场洞察，制定产品上市策略纲要，包括目标市场选择、渠道组合策略（零售高定/电商/工程）、竞争定位。" },
          { id: "gtm_2", code: "L3-01-03-02", name: "输出产品生命周期销量预测（第二版）", input: "上市策略、量价模型", output: "量价预测V2", note: "结合上市策略和渠道组合，输出更精确的分渠道、分区域量价预测，作为后续PDCP评审的关键输入。" },
        ],
        "产品线-MO": [
          { id: "prod_1", code: "L3-01-03-03", name: "明确产品定位与核心卖点", input: "需求图谱、竞品分析", output: "产品定位文档", note: "明确产品定位（如'智能马桶旗舰款'）、核心卖点排序（如脚感冲水、自动翻盖、UV杀菌等），形成产品卖点FAB文档。" },
        ],
        "财务经理": [
          { id: "fin_1", code: "L3-01-03-04", name: "输出产品生命周期财务概算", input: "量价预测、成本预测", output: "财务概算", note: "结合GTM给出的量价预测和成本经理给出的BOM成本预测，进行产品生命周期损益测算，评估项目财务可行性。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "prod_1", ""],
        ["gtm_1", "gtm_2", "上市策略纲要"],
        ["prod_1", "gtm_2", "产品定位文档"],
        ["gtm_2", "fin_1", "量价预测V2"],
        ["fin_1", "End", "财务概算"],
      ],
    },
    "可行性评估与立项决策": {
      code: "L2-01-04",
      start: "评估启动",
      end: "立项通过",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-01-04-01", name: "召开区域PCT启动会（Kick Off）", input: "上市策略、产品定位", output: "PCT成员名单、GTM Checklist", note: "组建PCT（产品商业化团队），明确GTM负责人、各域负责人和关键里程碑，下发GTM Checklist和五点三包预计输出时间。" },
          { id: "gtm_2", code: "L3-01-04-02", name: "编制立项建议书", input: "财务概算、需求图谱、风险评估", output: "立项建议书", note: "综合市场洞察、用户需求、产品概念、财务概算和风险评估，编制立项建议书，作为GR1评审的核心材料。" },
        ],
        "财务经理": [
          { id: "fin_1", code: "L3-01-04-03", name: "完成收益测算", input: "量价预测、成本数据", output: "收益测算报告", note: "完成产品生命周期收益测算，包括NPV、IRR、投资回收期等关键财务指标，为立项决策提供量化依据。" },
        ],
        "PCT团队": [
          { id: "pct_1", code: "L3-01-04-04", name: "评审GR1", input: "立项建议书、收益测算", output: "GR1评审结论", note: "PCT团队评审立项建议书，评估市场机会、产品概念、财务可行性和风险，给出通过/有条件通过/暂缓/不通过的结论。" },
        ],
        "GTM-MT委员": [
          { id: "mt_1", code: "L3-01-04-05", name: "决策CDCP", input: "GR1评审结论", output: "CDCP决策结论", note: "GTM-MT（管理团队）根据GR1评审结论进行立项决策（CDCP：概念决策检查点），决定项目是否进入下一阶段。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "fin_1", ""],
        ["gtm_1", "gtm_2", "PCT成员名单"],
        ["fin_1", "gtm_2", "收益测算报告"],
        ["gtm_2", "pct_1", "立项建议书"],
        ["pct_1", "mt_1", "GR1评审结论"],
        ["mt_1", "End", "CDCP决策结论"],
      ],
    },
  },
  expansion_preparation: {
    "产品定义确认": {
      code: "L2-02-01",
      start: "产品定义启动",
      end: "产品规格确认",
      lanes: {
        "产品线-MO": [
          { id: "prod_1", code: "L3-02-01-01", name: "输出产品规格书", input: "需求图谱、产品概念", output: "产品规格书", note: "基于需求图谱和产品概念，输出详细的产品规格书，包括功能参数、外观设计、材料工艺等技术规格。" },
          { id: "prod_2", code: "L3-02-01-02", name: "确认BOM与成本", input: "产品规格书", output: "BOM清单与成本预测", note: "根据产品规格确认BOM清单和制造成本预测，作为定价和财务测算的基础。" },
        ],
        "GTM": [
          { id: "gtm_1", code: "L3-02-01-03", name: "确认产品卖点FAB", input: "产品规格书、竞品分析", output: "产品卖点FAB文档", note: "确认产品特性（Feature）、优势（Advantage）、利益（Benefit）的FAB话术，为后续营销传播和导购培训提供标准口径。" },
        ],
        "服务经理": [
          { id: "svc_1", code: "L3-02-01-04", name: "评估服务交付约束", input: "产品规格书", output: "服务交付评估报告", note: "评估产品的安装条件、售后维修方案、备件策略，输出服务交付约束条件清单。" },
        ],
      },
      connections: [
        ["Start", "prod_1", ""],
        ["prod_1", "prod_2", "产品规格书"],
        ["prod_1", "gtm_1", "产品规格书"],
        ["prod_1", "svc_1", "产品规格书"],
        ["prod_2", "End", "BOM清单"],
        ["gtm_1", "End", "FAB文档"],
        ["svc_1", "End", "服务评估"],
      ],
    },
    "上市路径设计": {
      code: "L2-02-02",
      start: "路径设计启动",
      end: "上市路径确认",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-02-02-01", name: "制定上市总计划", input: "产品定义、市场洞察", output: "上市总计划", note: "制定产品上市总计划，包括关键里程碑、阶段目标、资源配置和风险管理计划。" },
        ],
        "渠道经理": [
          { id: "ch_1", code: "L3-02-02-02", name: "设计渠道导入策略", input: "渠道反馈、上市策略", output: "渠道导入策略", note: "设计渠道导入策略，包括样板门店选择标准、渠道激励政策、经销商沟通计划。" },
        ],
        "电商经理": [
          { id: "ec_1", code: "L2-02-02-03", name: "设计电商首发策略", input: "电商洞察、上市策略", output: "电商首发方案", note: "设计电商首发策略，包括平台选择、首发活动方案、页面规划和流量获取计划。" },
        ],
        "营销经理": [
          { id: "mkt_1", code: "L3-02-02-04", name: "制定传播策略框架", input: "上市策略、产品卖点", output: "传播策略框架", note: "制定上市传播策略框架，包括核心传播主题、媒体组合、KOL合作策略和传播节奏。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["gtm_1", "ch_1", "上市总计划"],
        ["gtm_1", "ec_1", "上市总计划"],
        ["gtm_1", "mkt_1", "上市总计划"],
        ["ch_1", "End", "渠道导入策略"],
        ["ec_1", "End", "电商首发方案"],
        ["mkt_1", "End", "传播策略框架"],
      ],
    },
    "目标渠道与客群规划": {
      code: "L2-02-03",
      start: "客群规划启动",
      end: "客群规划确认",
      lanes: {
        "渠道经理": [
          { id: "ch_1", code: "L3-02-03-01", name: "输出目标门店清单", input: "渠道导入策略", output: "目标门店清单", note: "根据渠道导入策略，筛选并输出首批目标门店清单，包括门店等级、区域分布和导入优先级。" },
        ],
        "电商经理": [
          { id: "ec_1", code: "L3-02-03-02", name: "确认电商目标客群", input: "电商消费者洞察", output: "电商客群画像", note: "确认电商渠道的目标客群画像，包括购买场景、价格敏感度和转化路径。" },
        ],
        "GTM": [
          { id: "gtm_1", code: "L3-02-03-03", name: "汇总客群规划", input: "目标门店、电商客群", output: "客群规划总报告", note: "汇总零售和电商渠道的客群规划，形成统一的客群规划总报告。" },
        ],
      },
      connections: [
        ["Start", "ch_1", ""],
        ["Start", "ec_1", ""],
        ["ch_1", "gtm_1", "目标门店清单"],
        ["ec_1", "gtm_1", "电商客群画像"],
        ["gtm_1", "End", "客群规划总报告"],
      ],
    },
    "项目资源配置与计划编制": {
      code: "L2-02-04",
      start: "资源配置启动",
      end: "项目计划确认",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-02-04-01", name: "编制项目WBS", input: "上市总计划、各域输入", output: "项目WBS", note: "编制项目工作分解结构（WBS），明确各阶段、各域的工作包、负责人和时间节点。" },
          { id: "gtm_2", code: "L3-02-04-02", name: "召开PCT评审会", input: "项目WBS、资源配置", output: "PCT评审结论", note: "召开PCT团队评审会，评审项目计划、资源配置和风险，确认项目进入执行阶段。" },
        ],
        "财经协同人": [
          { id: "fin_1", code: "L3-02-04-03", name: "确认项目预算", input: "财务概算、项目WBS", output: "项目预算", note: "根据项目WBS和财务概算，确认各域的项目预算分配和审批流程。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "fin_1", ""],
        ["gtm_1", "gtm_2", "项目WBS"],
        ["fin_1", "gtm_2", "项目预算"],
        ["gtm_2", "End", "PCT评审结论"],
      ],
    },
  },
  launch_preparation: {
    "上市成熟度检查": {
      code: "L2-04-01",
      start: "上市前检查启动",
      end: "DCP4决策通过",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-04-01-01", name: "检查区域操盘方案落地情况", input: "操盘方案、渠道计划", output: "操盘方案落地检查报告", note: "对照前期制定的区域操盘方案，逐项检查渠道覆盖、门店导入、营销资源、人员配置等是否按计划落地。" },
          { id: "gtm_2", code: "L3-04-01-04", name: "把控上市准备度", input: "各域准备度报告", output: "上市准备度总评估", note: "汇总物料、培训、服务、库存、系统等各域准备情况，形成上市准备度总评估，判断是否满足上市条件。" },
        ],
        "PDT经理": [
          { id: "pdt_1", code: "L3-04-01-02", name: "把控产品上市时间及风险", input: "项目进度、风险清单", output: "上市时间及风险评估", note: "评估产品开发进度、供应链 readiness、市场窗口期，识别上市时间风险和应对措施。" },
        ],
        "区域/国家GTM": [
          { id: "reg_1", code: "L3-04-01-03", name: "检查产品上市准备度(checklist)", input: "上市准备度checklist", output: "区域准备度确认", note: "按上市准备度checklist逐项检查区域层面的准备情况，包括物料到位、培训完成、库存就绪等。" },
        ],
        "PCT团队": [
          { id: "pct_1", code: "L3-04-01-05", name: "评审GR4", input: "上市准备度总评估", output: "GR4评审结论", note: "PCT团队召开GR4评审会，评估上市准备度是否达标，给出通过/有条件通过/暂缓的结论。", review: true },
          { id: "pct_2", code: "L3-04-01-06", name: "评审GR5", input: "GR4整改项", output: "GR5评审结论", note: "在GR4有条件通过的情况下，召开GR5评审会，确认整改项是否闭环，判断是否可以进入上市销售阶段。", review: true },
        ],
        "GTM-MT委员": [
          { id: "mt_1", code: "L3-04-01-07", name: "决策DCP4", input: "GR5评审结论", output: "DCP4决策结论", note: "GTM-MT根据GR5评审结论进行上市决策（DCP4：上市决策检查点），决定产品是否可以正式首发上市。", review: true },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "pdt_1", ""],
        ["Start", "reg_1", ""],
        ["gtm_1", "gtm_2", "操盘方案检查报告"],
        ["pdt_1", "gtm_2", "时间风险评估"],
        ["reg_1", "gtm_2", "区域准备度确认"],
        ["gtm_2", "pct_1", "上市准备度总评估"],
        ["pct_1", "pct_2", "GR4评审结论"],
        ["pct_2", "mt_1", "GR5评审结论"],
        ["mt_1", "End", "DCP4决策结论"],
      ],
    },
    "物料准备": {
      code: "L2-04-02",
      start: "物料准备启动",
      end: "物料全部到位",
      lanes: {
        "营销经理": [
          { id: "mkt_1", code: "L3-04-02-01", name: "输出主视觉及宣传物料", input: "产品卖点、品牌规范", output: "主视觉及宣传物料包", note: "基于产品卖点和品牌视觉规范，设计并输出主视觉KV、海报、视频、详情页等核心宣传物料。" },
        ],
        "零售经理": [
          { id: "ret_1", code: "L3-04-02-02", name: "输出零售培训材料，零售物料交付", input: "产品规格、卖点FAB", output: "零售培训材料包", note: "制作零售端培训材料（产品手册、卖点卡、对比表）和零售物料（台卡、吊旗、地贴等）。" },
          { id: "ret_2", code: "L3-04-02-04", name: "确认终端陈列标准及道具", input: "零售物料、陈列方案", output: "终端陈列标准手册", note: "确认终端门店的陈列标准、道具配置和出样方案，确保品牌形象统一。" },
          { id: "ret_3", code: "L3-04-02-05", name: "执行零售物料作业及零售培训", input: "零售物料、培训材料", output: "零售物料到位确认", note: "将零售物料下发至各区域门店，并组织零售培训，确保门店导购掌握产品知识和销售话术。" },
        ],
        "电商经理": [
          { id: "ec_1", code: "L3-04-02-03", name: "落地电商运营方案及物料", input: "电商首发方案", output: "电商运营物料包", note: "完成电商平台详情页、主图、视频、活动页等运营物料的制作和上传，确保电商页面就绪。" },
        ],
      },
      connections: [
        ["Start", "mkt_1", ""],
        ["Start", "ret_1", ""],
        ["Start", "ec_1", ""],
        ["mkt_1", "ret_2", "主视觉及宣传物料包"],
        ["ret_1", "ret_3", "零售培训材料包"],
        ["ec_1", "ret_3", "电商运营物料包"],
        ["ret_2", "End", "终端陈列标准手册"],
        ["ret_3", "End", "零售物料到位确认"],
      ],
    },
    "培训准备": {
      code: "L2-04-03",
      start: "培训准备启动",
      end: "培训考核完成",
      lanes: {
        "零售经理": [
          { id: "ret_1", code: "L3-04-03-01", name: "完成导购培训及话术考核", input: "零售培训材料、产品知识", output: "导购培训完成确认单", note: "组织全国/区域导购进行产品知识、销售话术、陈列标准的培训和考核，确保一线销售能力达标。" },
        ],
        "渠道经理": [
          { id: "ch_1", code: "L3-04-03-02", name: "完成渠道培训及政策宣导", input: "渠道政策、上市计划", output: "渠道培训记录", note: "对经销商和渠道合作伙伴进行新品政策、价格体系、激励机制的培训和宣导，确保渠道理解一致。" },
        ],
      },
      connections: [
        ["Start", "ret_1", ""],
        ["Start", "ch_1", ""],
        ["ret_1", "End", "导购培训完成确认单"],
        ["ch_1", "End", "渠道培训记录"],
      ],
    },
    "服务准备": {
      code: "L2-04-04",
      start: "服务准备启动",
      end: "服务 readiness 确认",
      lanes: {
        "服务经理": [
          { id: "svc_1", code: "L3-04-04-01", name: "本地化服务方案", input: "产品规格、服务标准", output: "本地化服务方案", note: "根据产品特性和区域市场差异，制定本地化的安装、维修、保养服务方案，明确服务标准和响应时效。" },
          { id: "svc_2", code: "L3-04-04-02", name: "建立售后知识库及工单预案", input: "产品技术资料、FAQ", output: "售后知识库V1.0", note: "建立售后服务知识库，包含产品技术参数、常见故障处理、安装指南等；制定工单处理预案和备件调配计划。" },
          { id: "svc_3", code: "L3-04-04-03", name: "检查服务准备度", input: "售后知识库、服务方案", output: "服务准备度确认", note: "检查售后团队人员配置、知识库上线、备件库存、服务网点覆盖是否满足上市后的服务需求。" },
        ],
      },
      connections: [
        ["Start", "svc_1", ""],
        ["svc_1", "svc_2", "本地化服务方案"],
        ["svc_2", "svc_3", "售后知识库V1.0"],
        ["svc_3", "End", "服务准备度确认"],
      ],
    },
    "库存和交付准备": {
      code: "L2-04-05",
      start: "库存准备启动",
      end: "首批交付就绪",
      lanes: {
        "渠道经理": [
          { id: "ch_1", code: "L3-04-05-01", name: "输出渠道要货预测", input: "渠道计划、销售目标", output: "渠道要货预测", note: "基于渠道导入计划和分区域销售目标，输出渠道层面的要货预测，作为供应链备料的输入。" },
        ],
        "供应链经理": [
          { id: "sc_1", code: "L3-04-05-02", name: "评估及确认国家首批订单及发货需求", input: "渠道要货预测", output: "首单备料计划", note: "评估各国家/区域的首批订单需求，确认SKU配比、数量和交付时间要求，制定首单备料计划。" },
          { id: "sc_2", code: "L3-04-05-03", name: "确定M+6要货预测", input: "首单备料计划、历史数据", output: "M+6要货预测", note: "结合首单需求和未来6个月销售预测，确定M+6滚动要货预测，指导生产和库存规划。" },
          { id: "sc_3", code: "L3-04-05-04", name: "检查产品交付能力", input: "M+6要货预测、产能数据", output: "交付能力评估报告", note: "检查工厂产能、物流能力和供应商 readiness，评估是否能满足要货预测中的交付要求。" },
          { id: "sc_4", code: "L3-04-05-05", name: "检查全球发货情况（含首批发货执行）", input: "交付能力评估", output: "全球发货执行确认", note: "跟踪首批订单的生产进度和物流状态，确认全球发货计划执行情况，确保上市前产品到位。" },
        ],
      },
      connections: [
        ["Start", "ch_1", ""],
        ["ch_1", "sc_1", "渠道要货预测"],
        ["sc_1", "sc_2", "首单备料计划"],
        ["sc_2", "sc_3", "M+6要货预测"],
        ["sc_3", "sc_4", "交付能力评估报告"],
        ["sc_4", "End", "全球发货执行确认"],
      ],
    },
    "系统及数据准备": {
      code: "L2-04-06",
      start: "系统准备启动",
      end: "系统上线就绪",
      lanes: {
        "营销经理": [
          { id: "mkt_1", code: "L3-04-06-01", name: "检查发布会准备度", input: "发布会方案、物料清单", output: "发布会准备度确认", note: "检查发布会场地、嘉宾邀请、媒体邀约、演示设备、传播素材等是否全部就绪。" },
        ],
        "电商经理": [
          { id: "ec_1", code: "L3-04-06-02", name: "检查电商准备度", input: "电商运营物料、页面方案", output: "电商准备度确认", note: "检查电商平台页面（Listing、详情页、主图、视频）、价格设置、库存同步、活动报名等是否全部就绪。" },
        ],
      },
      connections: [
        ["Start", "mkt_1", ""],
        ["Start", "ec_1", ""],
        ["mkt_1", "End", "发布会准备度确认"],
        ["ec_1", "End", "电商准备度确认"],
      ],
    },
  },
  launch_sales: {
    "首发上市执行": {
      code: "L2-05-01",
      start: "首发上市启动",
      end: "首销复盘完成",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-05-01-01", name: "协调各部门上市执行准备", input: "DCP4决策结论", output: "上市执行准备确认单", note: "协调营销、渠道、零售、电商、服务、供应链等各域，确认上市执行前的最后准备事项全部到位。" },
          { id: "gtm_2", code: "L3-05-01-02", name: "确认首发时间及销售策略", input: "上市执行准备确认", output: "首发执行计划", note: "最终确认首发时间、首发价格、首发渠道、首发库存分配和首销目标，形成首发执行计划。" },
          { id: "gtm_3", code: "L3-05-01-07", name: "监控首发上市执行及反馈收集", input: "首发执行计划", output: "首销监控日报", note: "实时监控首发上市执行情况，收集销售数据、用户反馈、媒体声量等，输出首销监控日报。" },
          { id: "gtm_4", code: "L3-05-01-08", name: "监控区域首销及竞争情况", input: "首销监控日报", output: "区域首销分析报告", note: "分区域监控首销表现，对比竞品同期动作，分析市场份额变化和竞争态势。" },
          { id: "gtm_5", code: "L3-05-01-09", name: "监控区域操盘方案执行及销售", input: "区域首销分析", output: "操盘方案执行评估", note: "评估区域操盘方案（价格、促销、渠道策略）的执行效果，识别偏差并提出调整建议。" },
          { id: "gtm_6", code: "L3-05-01-10", name: "监控每周SO达成情况及竞品价格", input: "销售数据、竞品监测", output: "每周SO及竞品监控报告", note: "每周跟踪Sell Out达成情况、库存周转和竞品价格动态，及时发现销售异常和市场机会。" },
          { id: "gtm_7", code: "L3-05-01-12", name: "复盘首销上市情况，输出首销上市复盘报告", input: "首销监控日报、区域分析", output: "首销复盘报告", note: "汇总首销期间的销售数据、用户反馈、渠道表现和竞争情况，输出首销上市复盘报告，为后续销售策略调整提供依据。" },
        ],
        "营销经理": [
          { id: "mkt_1", code: "L3-05-01-03", name: "召开产品发布会", input: "发布会准备度确认", output: "发布会执行报告", note: "执行产品发布会，包括媒体沟通、KOL体验、直播带货等，确保发布会传播效果最大化。" },
        ],
        "供应链经理": [
          { id: "sc_1", code: "L3-05-01-04", name: "检查实际交付情况", input: "发货计划、物流跟踪", output: "实际交付情况报告", note: "检查首批订单的实际交付进度，确认各区域到货情况，处理交付延迟或缺货问题。" },
        ],
        "零售经理": [
          { id: "ret_1", code: "L3-05-01-05", name: "监控零售方案的执行情况", input: "零售方案、门店销售数据", output: "零售方案执行监控报告", note: "监控零售端陈列、导购话术、促销活动的执行情况，收集门店反馈，确保零售策略落地。" },
        ],
        "服务经理": [
          { id: "svc_1", code: "L3-05-01-06", name: "监控服务方案执行情况", input: "服务方案、售后工单", output: "服务执行监控报告", note: "监控售后服务响应时效、安装质量、客户满意度，确保服务承诺兑现，及时处理服务投诉。" },
        ],
        "电商经理": [
          { id: "ec_1", code: "L3-05-01-11", name: "复盘电商首销情况，输出电商复盘报告", input: "电商销售数据、流量数据", output: "电商首销复盘报告", note: "分析电商首销期间的流量、转化、客单价、用户评价等数据，输出电商首销复盘报告。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["gtm_1", "gtm_2", "上市执行准备确认单"],
        ["gtm_2", "mkt_1", "首发执行计划"],
        ["mkt_1", "gtm_3", "发布会执行报告"],
        ["gtm_3", "sc_1", "首销监控日报"],
        ["gtm_3", "ret_1", "首销监控日报"],
        ["gtm_3", "svc_1", "首销监控日报"],
        ["sc_1", "gtm_4", "实际交付情况报告"],
        ["ret_1", "gtm_5", "零售方案执行监控报告"],
        ["svc_1", "gtm_5", "服务执行监控报告"],
        ["gtm_4", "gtm_6", "区域首销分析报告"],
        ["gtm_5", "gtm_6", "操盘方案执行评估"],
        ["gtm_6", "ec_1", "每周SO及竞品监控报告"],
        ["ec_1", "gtm_7", "电商首销复盘报告"],
        ["gtm_6", "gtm_7", "每周SO及竞品监控报告"],
        ["gtm_7", "End", "首销复盘报告"],
      ],
    },
    "终端导入与渠道激活": {
      code: "L2-05-02",
      start: "渠道激活启动",
      end: "渠道动销稳定",
      lanes: {
        "渠道经理": [
          { id: "ch_1", code: "L3-05-02-01", name: "监控渠道PSI及日常管理", input: "渠道销售数据、PSI报表", output: "渠道PSI监控报告", note: "监控渠道进销存（Purchase/Sales/Inventory）数据，管理渠道库存水位，防止压货或断货。" },
        ],
        "GTM": [
          { id: "gtm_1", code: "L3-05-02-02", name: "管理每周PSI", input: "各区域PSI数据", output: "每周PSI管理报告", note: "汇总各区域每周PSI数据，分析渠道库存健康度、Sell In/Sell Out差异，协调供应链调整发货节奏。" },
        ],
        "供应链经理": [
          { id: "sc_1", code: "L3-05-02-03", name: "管理滚动要货计划", input: "PSI数据、销售预测", output: "滚动要货计划", note: "基于PSI数据和销售预测，制定并调整滚动要货计划，确保供应链与市场需求匹配。" },
        ],
      },
      connections: [
        ["Start", "ch_1", ""],
        ["Start", "gtm_1", ""],
        ["ch_1", "gtm_1", "渠道PSI监控报告"],
        ["gtm_1", "sc_1", "每周PSI管理报告"],
        ["sc_1", "End", "滚动要货计划"],
      ],
    },
    "上市传播与转化运营": {
      code: "L2-05-03",
      start: "传播运营启动",
      end: "IMC复盘完成",
      lanes: {
        "营销经理": [
          { id: "mkt_1", code: "L3-05-03-01", name: "监控营销方案执行", input: "IMC方案、投放计划", output: "营销执行监控报告", note: "监控IMC（整合营销传播）方案的执行情况，包括广告投放、内容传播、PR活动、KOL合作等的执行进度和效果。" },
          { id: "mkt_2", code: "L3-05-03-04", name: "复盘IMC执行情况，输出复盘报告", input: "营销数据、传播效果", output: "IMC方案复盘报告", note: "汇总IMC执行期间的曝光量、互动率、转化效果、ROI等数据，评估传播策略的有效性，输出复盘报告。" },
        ],
        "电商经理": [
          { id: "ec_1", code: "L3-05-03-02", name: "监控电商方案执行情况", input: "电商运营计划", output: "电商执行监控报告", note: "监控电商平台的流量获取、转化率、客单价、用户评价等指标，评估电商运营方案的执行效果。" },
        ],
        "财务经理": [
          { id: "fin_1", code: "L3-05-03-03", name: "执行及监控预算达成进度", input: "营销预算、费用申请", output: "预算达成进度报告", note: "监控营销费用和电商费用的实际支出与预算的差异，分析预算执行效率，预警超支风险。" },
        ],
      },
      connections: [
        ["Start", "mkt_1", ""],
        ["Start", "ec_1", ""],
        ["mkt_1", "fin_1", "营销执行监控报告"],
        ["ec_1", "fin_1", "电商执行监控报告"],
        ["fin_1", "mkt_2", "预算达成进度报告"],
        ["mkt_2", "End", "IMC方案复盘报告"],
      ],
    },
    "首销复盘": {
      code: "L2-05-04",
      start: "复盘启动",
      end: "DCP5决策通过",
      lanes: {
        "PDT经理": [
          { id: "pdt_1", code: "L3-05-04-01", name: "收集产品市场反馈", input: "用户评价、VOC数据", output: "产品市场反馈汇总", note: "收集首销期间的用户评价、售后反馈、市场调研数据，形成产品市场反馈汇总，识别产品改进点。" },
        ],
        "GTM-MT委员": [
          { id: "mt_1", code: "L3-05-04-02", name: "决策DCP5", input: "首销复盘报告、产品反馈", output: "DCP5决策结论", note: "GTM-MT召开DCP5决策会，基于首销复盘报告和产品市场反馈，决策产品是否进入稳定销售阶段，或需要调整策略后重新上市。", review: true },
        ],
      },
      connections: [
        ["Start", "pdt_1", ""],
        ["pdt_1", "mt_1", "产品市场反馈汇总"],
        ["mt_1", "End", "DCP5决策结论"],
      ],
    },
  },
  market_expansion: {
    "渠道拓展准备": {
      code: "L2-03-01",
      start: "渠道拓展启动",
      end: "渠道导入方案确认",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-03-01-01", name: "制定渠道拓展及覆盖计划", input: "上市策略纲要、目标客群规划", output: "渠道拓展计划", note: "基于上市策略纲要和客群规划，制定渠道拓展及覆盖计划，明确目标渠道类型（零售高定/电商/工程）、覆盖区域和拓展节奏。" },
          { id: "gtm_2", code: "L3-03-01-02", name: "制定渠道政策及费用预算", input: "渠道拓展计划", output: "渠道政策及费用预算", note: "设计渠道激励政策（返利、费用补贴、陈列奖励等），编制渠道费用预算，确保渠道拓展资源到位。" },
        ],
        "渠道经理": [
          { id: "ch_1", code: "L3-03-01-03", name: "评估目标渠道准入条件", input: "渠道拓展计划", output: "渠道准入评估报告", note: "评估各目标渠道的准入门槛、合作条件和费用要求，输出渠道准入评估报告，筛选优先拓展渠道。" },
          { id: "ch_2", code: "L3-03-01-04", name: "设计渠道导入方案", input: "渠道准入评估、渠道政策", output: "渠道导入方案", note: "针对目标渠道制定导入方案，包括首批上架门店清单、铺货计划、经销商沟通计划和渠道激励落地措施。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "ch_1", ""],
        ["gtm_1", "gtm_2", "渠道拓展计划"],
        ["gtm_1", "ch_1", "渠道拓展计划"],
        ["ch_1", "ch_2", "渠道准入评估报告"],
        ["gtm_2", "ch_2", "渠道政策及费用预算"],
        ["ch_2", "End", "渠道导入方案"],
      ],
    },
    "市场推广策略设计": {
      code: "L2-03-02",
      start: "推广策略启动",
      end: "推广策略评审通过",
      lanes: {
        "营销经理": [
          { id: "mkt_1", code: "L3-03-02-01", name: "制定IMC整合营销方案", input: "产品卖点、目标客群画像", output: "IMC整合营销方案", note: "基于产品核心卖点和目标用户画像，制定IMC整合营销传播方案，包括传播主题、媒体组合、KOL合作策略和传播节奏规划。" },
          { id: "mkt_2", code: "L3-03-02-02", name: "制定营销策略纲要及预算", input: "IMC方案", output: "营销策略纲要及预算", note: "将IMC方案细化为可执行的营销策略纲要，编制分阶段营销预算（含广告投放、PR活动、KOL合作等），明确各阶段费用分配。" },
        ],
        "电商经理": [
          { id: "ec_1", code: "L3-03-02-03", name: "设计电商运营策略", input: "IMC方案、电商客群画像", output: "电商运营策略", note: "设计电商平台运营策略，包括平台选择、流量获取计划、促销活动规划、页面优化方案和评价管理策略。" },
        ],
        "GTM": [
          { id: "gtm_1", code: "L3-03-02-04", name: "评审推广策略及预算", input: "IMC方案、电商策略、营销预算", output: "推广策略评审结论", note: "组织评审IMC方案、电商运营策略和营销预算，评估策略完整性和预算合理性，输出评审结论。" },
        ],
      },
      connections: [
        ["Start", "mkt_1", ""],
        ["Start", "ec_1", ""],
        ["mkt_1", "mkt_2", "IMC整合营销方案"],
        ["mkt_1", "ec_1", "IMC整合营销方案"],
        ["ec_1", "gtm_1", "电商运营策略"],
        ["mkt_2", "gtm_1", "营销策略纲要及预算"],
        ["gtm_1", "End", "推广策略评审结论"],
      ],
    },
    "产品卖点与内容资产准备": {
      code: "L2-03-03",
      start: "内容资产准备启动",
      end: "内容资产审核确认",
      lanes: {
        "产品线-MO": [
          { id: "prod_1", code: "L3-03-03-01", name: "输出产品卖点初稿", input: "产品规格书、竞品分析", output: "产品卖点初稿", note: "基于产品规格书和竞品对标分析，输出产品卖点FAB初稿（Feature特性/Advantage优势/Benefit利益），形成标准话术模板。" },
        ],
        "营销经理": [
          { id: "mkt_1", code: "L3-03-03-02", name: "制作内容资产", input: "产品卖点初稿", output: "内容资产包", note: "基于产品卖点，制作内容资产包，包括产品主视觉KV、宣传视频脚本、详情页文案、社媒传播素材等。" },
        ],
        "零售经理": [
          { id: "ret_1", code: "L3-03-03-03", name: "输出产品拓展包", input: "产品卖点初稿", output: "产品拓展包", note: "制作零售端产品拓展包，包括产品手册、卖点对比卡、竞品话术应对表、导购培训课件等终端销售支持材料。" },
        ],
        "GTM": [
          { id: "gtm_2", code: "L3-03-03-04", name: "审核内容资产及拓展包", input: "内容资产包、产品拓展包", output: "内容资产审核确认", note: "审核内容资产和产品拓展包的品牌调性一致性、卖点准确性和传播有效性，输出审核确认意见。" },
        ],
      },
      connections: [
        ["Start", "prod_1", ""],
        ["prod_1", "mkt_1", "产品卖点初稿"],
        ["prod_1", "ret_1", "产品卖点初稿"],
        ["mkt_1", "gtm_2", "内容资产包"],
        ["ret_1", "gtm_2", "产品拓展包"],
        ["gtm_2", "End", "内容资产审核确认"],
      ],
    },
    "上市资源前置协同": {
      code: "L2-03-04",
      start: "资源协同启动",
      end: "资源协同就绪确认",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-03-04-01", name: "筹备新品物料", input: "内容资产包、渠道导入方案", output: "新品物料筹备计划", note: "汇总内容资产和渠道方案，制定新品物料筹备计划，包括终端陈列物料、宣传物料、销售工具包的制作和分发时间表。" },
          { id: "gtm_2", code: "L3-03-04-02", name: "协调操盘方案落地", input: "新品物料筹备计划、渠道导入方案", output: "操盘方案", note: "协调各域资源，整合渠道导入、营销推广、物料准备和供应链保障，形成可执行的区域操盘方案。" },
        ],
        "供应链经理": [
          { id: "sc_1", code: "L3-03-04-03", name: "输出M+6要货预测", input: "渠道拓展计划、销售目标", output: "M+6要货预测", note: "基于渠道拓展计划和销售目标，输出未来6个月滚动要货预测，指导工厂备料和生产排期。" },
        ],
        "产品经理": [
          { id: "prod_1", code: "L3-03-04-04", name: "定制化需求评审", input: "区域定制化需求", output: "定制化需求评审结论", note: "评审各区域提出的定制化需求（如本地化功能、包装语言、认证要求等），评估技术可行性和成本影响，输出评审结论。" },
        ],
        "服务经理": [
          { id: "svc_1", code: "L3-03-04-05", name: "制定服务方案初稿", input: "产品规格、渠道计划", output: "服务方案初稿", note: "根据产品特性和渠道计划，制定安装维修服务方案初稿，明确服务网点覆盖、备件策略和服务标准。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "sc_1", ""],
        ["Start", "prod_1", ""],
        ["gtm_1", "gtm_2", "新品物料筹备计划"],
        ["sc_1", "gtm_2", "M+6要货预测"],
        ["prod_1", "svc_1", "定制化需求评审结论"],
        ["gtm_2", "End", "操盘方案"],
        ["svc_1", "End", "服务方案初稿"],
      ],
    },
  },
  stable_sales: {
    "动销监控": {
      code: "L2-06-01",
      start: "动销监控启动",
      end: "动销数据汇报完成",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-06-01-01", name: "管理每周PSI", input: "各区域PSI数据", output: "每周PSI管理报告", note: "汇总各区域每周Purchase/Sales/Inventory数据，分析渠道库存健康度、进销存差异，协调供应链调整发货节奏。" },
          { id: "gtm_2", code: "L3-06-01-02", name: "监控SO达成及竞品价格", input: "销售数据、竞品监测", output: "SO及竞品监控报告", note: "每周跟踪Sell Out达成率、终端零售表现和竞品价格动态，识别销售异常和市场机会，输出SO及竞品监控周报。" },
        ],
        "渠道经理": [
          { id: "ch_1", code: "L3-06-01-03", name: "监控渠道动销数据", input: "渠道销售数据", output: "渠道动销分析报告", note: "监控渠道终端动销情况，分析各渠道类型（零售/电商/工程）的销售趋势和库存周转，识别动销不畅的渠道和区域。" },
        ],
        "供应链经理": [
          { id: "sc_1", code: "L3-06-01-04", name: "执行滚动要货计划", input: "PSI数据、销售预测", output: "滚动要货计划", note: "基于PSI数据和销售预测，制定并调整滚动要货计划，确保供应链与市场需求匹配，避免断货或库存积压。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "ch_1", ""],
        ["gtm_1", "gtm_2", "每周PSI管理报告"],
        ["ch_1", "gtm_2", "渠道动销分析报告"],
        ["gtm_2", "sc_1", "SO及竞品监控报告"],
        ["sc_1", "End", "滚动要货计划"],
      ],
    },
    "问题闭环与改进": {
      code: "L2-06-02",
      start: "问题监控启动",
      end: "改进计划确认",
      lanes: {
        "服务经理": [
          { id: "svc_1", code: "L3-06-02-01", name: "监控VOC及售后问题", input: "售后工单、用户评价", output: "VOC监控报告", note: "持续监控Voice of Customer数据，包括售后工单、用户评价、投诉热点，及时发现产品质量和服务问题。" },
          { id: "svc_2", code: "L3-06-02-02", name: "及时处理售后问题", input: "VOC监控报告", output: "售后问题处理记录", note: "针对VOC监控中发现的问题，协调售后团队及时处理，制定问题升级和闭环机制，确保客户满意度。" },
        ],
        "产品线-MO": [
          { id: "prod_1", code: "L3-06-02-03", name: "收集产品市场反馈", input: "VOC数据、竞品信息", output: "产品市场反馈汇总", note: "收集并汇总产品在市场端的反馈，包括功能改进建议、竞品对比信息、用户使用痛点等，形成产品改进输入。" },
        ],
        "GTM": [
          { id: "gtm_1", code: "L3-06-02-04", name: "推动问题闭环改进", input: "售后问题记录、市场反馈", output: "问题闭环改进计划", note: "基于售后处理记录和市场反馈，推动产品、服务和运营的改进措施，制定问题闭环改进计划并跟踪执行。" },
        ],
      },
      connections: [
        ["Start", "svc_1", ""],
        ["Start", "prod_1", ""],
        ["svc_1", "svc_2", "VOC监控报告"],
        ["svc_2", "gtm_1", "售后问题处理记录"],
        ["prod_1", "gtm_1", "产品市场反馈汇总"],
        ["gtm_1", "End", "问题闭环改进计划"],
      ],
    },
    "产品经营优化": {
      code: "L2-06-03",
      start: "经营优化启动",
      end: "优化方案确认",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-06-03-01", name: "调整销售节奏及策略", input: "SO监控报告、竞品动态", output: "销售策略调整方案", note: "基于SO达成情况和竞品动态，调整销售节奏和区域策略，包括促销节奏、价格策略、渠道资源分配等。" },
        ],
        "零售经理": [
          { id: "ret_1", code: "L3-06-03-02", name: "零售方案复盘", input: "零售执行数据", output: "零售方案复盘报告", note: "复盘零售端的陈列执行、导购表现、促销活动效果，评估零售策略有效性，提出优化建议。" },
        ],
        "服务经理": [
          { id: "svc_1", code: "L3-06-03-03", name: "服务阶段复盘", input: "服务工单数据、满意度", output: "服务复盘报告", note: "复盘售后服务的响应时效、解决率和客户满意度，评估服务策略执行效果，输出服务优化建议。" },
        ],
        "营销经理": [
          { id: "mkt_1", code: "L3-06-03-04", name: "调整营销及促销策略", input: "销售策略调整方案、零售复盘", output: "营销促销调整方案", note: "结合销售策略调整和零售复盘结论，优化营销传播和促销活动策略，提升营销投入产出比。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "ret_1", ""],
        ["Start", "svc_1", ""],
        ["gtm_1", "mkt_1", "销售策略调整方案"],
        ["ret_1", "mkt_1", "零售方案复盘报告"],
        ["svc_1", "mkt_1", "服务复盘报告"],
        ["mkt_1", "End", "营销促销调整方案"],
      ],
    },
    "资源调整与持续经营": {
      code: "L2-06-04",
      start: "资源调整启动",
      end: "持续经营方案确认",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-06-04-01", name: "输出月度经营数据", input: "销售数据、财务数据", output: "月度经营分析报告", note: "汇总月度销售、收入、利润、库存等经营数据，分析产品经营健康度，输出月度经营分析报告。" },
          { id: "gtm_2", code: "L3-06-04-02", name: "迭代产品规划", input: "市场反馈、经营数据", output: "产品迭代规划建议", note: "基于市场反馈和经营数据，评估产品迭代方向，提出功能升级、SKU调整或价格优化等产品规划建议。" },
        ],
        "财务经理": [
          { id: "fin_1", code: "L3-06-04-03", name: "管理预算达成进度", input: "预算执行数据", output: "预算达成进度报告", note: "监控各域费用的实际支出与预算的偏差，分析预算执行效率，预警超支风险，输出预算达成进度报告。" },
        ],
        "运营经理": [
          { id: "ops_1", code: "L3-06-04-04", name: "调整资源分配", input: "经营分析报告、预算进度", output: "资源调整方案", note: "基于经营分析和预算进度，调整营销费用、渠道费用和运营资源的分配，优化资源使用效率。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "fin_1", ""],
        ["gtm_1", "gtm_2", "月度经营分析报告"],
        ["fin_1", "ops_1", "预算达成进度报告"],
        ["gtm_2", "ops_1", "产品迭代规划建议"],
        ["ops_1", "End", "资源调整方案"],
      ],
    },
  },
  phase_out: {
    "退市判断": {
      code: "L2-07-01",
      start: "退市评估启动",
      end: "EOM公告发布",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-07-01-01", name: "评估产品生命周期阶段", input: "销售趋势、市场份额数据", output: "产品生命周期评估报告", note: "评估产品所处的生命周期阶段，分析销售趋势（连续下滑月数）、市场份额变化、毛利趋势，判断是否进入退市窗口。" },
          { id: "gtm_2", code: "L3-07-01-02", name: "制定退市方案", input: "生命周期评估报告", output: "退市方案", note: "制定退市方案，包括退市时间表、库存清尾目标、渠道沟通计划、价格调整策略和服务延续安排。" },
        ],
        "产品线-MO": [
          { id: "prod_1", code: "L3-07-01-03", name: "发布EOM公告", input: "退市方案", output: "EOM公告", note: "根据退市方案发布EOM（End of Maintenance/Marketing）公告，通知各区域和渠道合作伙伴产品退市计划和时间表。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["gtm_1", "gtm_2", "产品生命周期评估报告"],
        ["gtm_2", "prod_1", "退市方案"],
        ["prod_1", "End", "EOM公告"],
      ],
    },
    "库存与渠道处理": {
      code: "L2-07-02",
      start: "库存处理启动",
      end: "清尾方案执行完成",
      lanes: {
        "渠道经理": [
          { id: "ch_1", code: "L3-07-02-01", name: "制定渠道清尾方案", input: "退市方案、渠道库存数据", output: "渠道清尾方案", note: "统计渠道各层级库存数据，制定渠道清尾方案，明确各渠道的库存消化目标、时间节点和激励措施。" },
          { id: "ch_2", code: "L3-07-02-02", name: "执行Last Buy方案", input: "渠道清尾方案", output: "Last Buy执行记录", note: "执行Last Buy方案，通知经销商最后一批采购时间和数量限制，协调渠道完成尾货采购和库存消化。" },
        ],
        "供应链经理": [
          { id: "sc_1", code: "L3-07-02-03", name: "制定库存处理方案", input: "渠道清尾方案、库存数据", output: "库存处理方案", note: "根据渠道清尾进度和剩余库存，制定工厂及中央库存的处理方案，包括降价清仓、跨区域调拨或报废处理。" },
        ],
      },
      connections: [
        ["Start", "ch_1", ""],
        ["ch_1", "ch_2", "渠道清尾方案"],
        ["ch_1", "sc_1", "渠道清尾方案"],
        ["ch_2", "End", "Last Buy执行记录"],
        ["sc_1", "End", "库存处理方案"],
      ],
    },
    "价格与客户影响管理": {
      code: "L2-07-03",
      start: "价格管理启动",
      end: "客户沟通完成",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-07-03-01", name: "管理退市价格策略", input: "退市方案、市场价格数据", output: "退市价格策略", note: "制定退市期间的价格管理策略，包括阶段性降价计划、渠道价格保护政策和价格底线管控机制。" },
        ],
        "渠道经理": [
          { id: "ch_1", code: "L3-07-03-02", name: "执行客户沟通", input: "退市价格策略", output: "客户沟通记录", note: "按退市价格策略与经销商和终端客户沟通退市安排，处理客户异议，确保客户关系平稳过渡。" },
        ],
        "服务经理": [
          { id: "svc_1", code: "L3-07-03-03", name: "安排服务延续", input: "退市方案、客户清单", output: "服务延续方案", note: "制定退市产品的服务延续方案，包括售后保修期承诺、备件供应保障、替代产品推荐和客户迁移计划。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["gtm_1", "ch_1", "退市价格策略"],
        ["gtm_1", "svc_1", "退市价格策略"],
        ["ch_1", "End", "客户沟通记录"],
        ["svc_1", "End", "服务延续方案"],
      ],
    },
    "经验复盘与知识沉淀": {
      code: "L2-07-04",
      start: "复盘启动",
      end: "知识沉淀完成",
      lanes: {
        "GTM": [
          { id: "gtm_1", code: "L3-07-04-01", name: "产品生命周期复盘", input: "退市执行数据、经营数据", output: "产品生命周期复盘报告", note: "复盘产品从上市到退市的全生命周期表现，包括销量达成、市场份额、盈利能力、渠道表现和营销效果。" },
          { id: "gtm_2", code: "L3-07-04-02", name: "刷新产品路标", input: "生命周期复盘报告", output: "产品路标更新建议", note: "基于生命周期复盘结论，刷新产品路标，为下一代产品规划提供方向性建议和优先级排序。" },
        ],
        "财务经理": [
          { id: "fin_1", code: "L3-07-04-03", name: "输出经营分析报告", input: "全生命周期财务数据", output: "经营分析报告", note: "汇总产品全生命周期的收入、成本、费用和利润数据，输出完整的经营分析报告，评估产品投资回报。" },
        ],
        "产品线-MO": [
          { id: "prod_1", code: "L3-07-04-04", name: "知识沉淀与经验传承", input: "复盘报告、经营分析", output: "知识沉淀文档", note: "将产品全生命周期的经验教训（成功经验和失败教训）沉淀为知识文档，纳入组织知识库供后续产品参考。" },
        ],
      },
      connections: [
        ["Start", "gtm_1", ""],
        ["Start", "fin_1", ""],
        ["gtm_1", "gtm_2", "产品生命周期复盘报告"],
        ["fin_1", "prod_1", "经营分析报告"],
        ["gtm_2", "prod_1", "产品路标更新建议"],
        ["prod_1", "End", "知识沉淀文档"],
      ],
    },
  },
};

export const countdownPlan = [
  {
    "week": "上市 - 8 周",
    "items": [
      {
        "domain": "GTM",
        "action": "市场洞察（含竞品）"
      },
      {
        "domain": "运营",
        "action": "运营新玩法洞察"
      },
      {
        "domain": "MKT / 流量",
        "action": "流量入口洞察"
      }
    ]
  },
  {
    "week": "上市 - 7 周",
    "items": [
      {
        "domain": "GTM",
        "action": "组织复盘会议 + 新品宣讲（Kick Off）"
      },
      {
        "domain": "运营",
        "action": "老品运营复盘"
      },
      {
        "domain": "MKT / 流量",
        "action": "流量投放复盘"
      },
      {
        "domain": "供应链 / 交付",
        "action": "要货准确率复盘"
      },
      {
        "domain": "财经",
        "action": "老品生命周期损益复盘（销量 / 收入 / ASP）"
      }
    ]
  },
  {
    "week": "上市 - 6 周",
    "items": [
      {
        "domain": "GTM",
        "action": "GTM会议-决定“量”"
      },
      {
        "domain": "GTM",
        "action": "定价测算"
      },
      {
        "domain": "GTM",
        "action": "投放预算"
      },
      {
        "domain": "GTM",
        "action": "生命周期损益测算"
      },
      {
        "domain": "运营",
        "action": "新品物料包计划"
      },
      {
        "domain": "运营",
        "action": "运营动作规划"
      },
      {
        "domain": "MKT / 流量",
        "action": "流量预算分配（初稿）"
      },
      {
        "domain": "供应链 / 交付",
        "action": "物流交付"
      },
      {
        "domain": "财经",
        "action": "成本 / 费用提交"
      }
    ]
  },
  {
    "week": "上市 - 5 周",
    "items": [
      {
        "domain": "GTM",
        "action": "GTM 会议 - 决定 “时间点 / 价格”"
      },
      {
        "domain": "GTM",
        "action": "输出生命周期促销地图"
      },
      {
        "domain": "运营",
        "action": "活动运营匹配促销地图"
      },
      {
        "domain": "MKT / 流量",
        "action": "流量节奏匹配促销地图"
      },
      {
        "domain": "供应链 / 交付",
        "action": "交付节奏匹配促销地图"
      },
      {
        "domain": "财经",
        "action": "根据 “量价时” 做经营损益测算"
      }
    ]
  },
  {
    "week": "上市 - 4 周",
    "items": [
      {
        "domain": "GTM",
        "action": "GTM 会议审视上市计划"
      },
      {
        "domain": "GTM",
        "action": "整体上市方案统筹"
      },
      {
        "domain": "运营",
        "action": "运营方案"
      },
      {
        "domain": "MKT / 流量",
        "action": "流量方案（终稿）"
      },
      {
        "domain": "供应链 / 交付",
        "action": "到货进展"
      }
    ]
  },
  {
    "week": "上市 - 3 周",
    "items": [
      {
        "domain": "GTM",
        "action": "GTM 会议 - 审视准备进度"
      },
      {
        "domain": "GTM",
        "action": "首销目标确定"
      },
      {
        "domain": "运营",
        "action": "物料准备 / 运营动作执行"
      },
      {
        "domain": "运营",
        "action": "Listing 上传"
      },
      {
        "domain": "MKT / 流量",
        "action": "变体方案"
      },
      {
        "domain": "供应链 / 交付",
        "action": "库存 Ready"
      }
    ]
  },
  {
    "week": "上市 - 2 周",
    "items": [
      {
        "domain": "GTM",
        "action": "GTM 会议 - 审视进度"
      },
      {
        "domain": "运营",
        "action": "页面预览审核（B+A+）"
      },
      {
        "domain": "运营",
        "action": "设置开售时间"
      },
      {
        "domain": "MKT / 流量",
        "action": "创建词组"
      }
    ]
  },
  {
    "week": "上市 - 1 周",
    "items": [
      {
        "domain": "GTM",
        "action": "GTM 会议"
      },
      {
        "domain": "运营",
        "action": "页面上线预热"
      },
      {
        "domain": "MKT / 流量",
        "action": "根据预算调整 Bidding 价格"
      }
    ]
  }
];
